(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-recommendations"]) return;
  try {
    

  const initRelatedCarousel = () => {      
    const relatedCarousel = new Splide('#related-products', {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: '10px',
      pagination: false,
      arrows: false,
      mediaQuery: 'min',
      arrowPath: 'M1.86,20A18.14,18.14,0,1,1,20,38.14,18.14,18.14,0,0,1,1.86,20ZM0,20A20,20,0,1,1,20,40,20,20,0,0,1,0,20Zm17.48,5.39L18.8,26.7,25.5,20l-6.7-6.7-1.32,1.31L22.87,20Z',
      breakpoints: {
        768: {
          arrows: true,
          perPage: 2,
          perMove: 1
        },
        1280: {
          perPage: 3,
          perMove: 1
        }
      }
    })      
    relatedCarousel.mount()
  }

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        // Use DOMParser instead of innerHTML to avoid XSS risk
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = doc.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          // Replace children via DOM methods — never assign raw HTML strings
          productRecommendationsSection.replaceChildren(...recommendations.childNodes);
        }
        initRelatedCarousel();
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
